import {
  getWithExpiry,
  setWithExpiry
} from 'shared-assets/lib/utils/sessionStorage';
const TTL_IN_SECONDS = 900;
const SESSION_STORAGE_PREFIX = 'notificationCount';
const SESSION_ID_COOKIE_NAME = '_conv_sid';
const OPEN_MESSAGE_CENTER_V2 = 'open-message-center-v2';
const CLOSE_DROPDOWN_PREVIEW = 'close-dropdown-preview';

angular.module('kareo.ui.shared.directives.messaging-dropdown', [
  'kareo.ui.shared.modules.featureSet',
  'kareo.ui.shared.modules.iframe-modal-service',
  'kareo.ui.shared.modules.data',
  'kareo.errors'])
  .controller('MessagingDropdownMenuCtrl', [
    '$scope',
    'IFrameModalService',
    'NotificationCountService',
    'featureSet',
    '$rootScope',
    '$cookies',
    '$window',
    '$timeout',
    function ($scope, IFrameModalService, NotificationCountService, featureSet, $rootScope, $cookies, $window, $timeout) {
      $scope.notificationCount = NotificationCountService.notificationCount;
      $scope.openDropdown = function () {
        $scope.notificationCount.newMessageCount = 0;
        const sid = $cookies.get(SESSION_ID_COOKIE_NAME);
        setWithExpiry(SESSION_STORAGE_PREFIX, sid, 0, TTL_IN_SECONDS);
        const url = $scope.isMessageCenterV2Enabled ? '/v2/#messages-ui/preview' : '/messages-ui/dropdown/';

        const handleIframeClose = function () {
          IFrameModalService.cancel();
          removeMessageListener();
        };

        // Listen for close message from iframe in v2
        const handleMessage = function (event) {
          if (event.origin !== $window.location.origin) {
            return;
          }
          const messageType = event.data?.type;
          if (messageType === OPEN_MESSAGE_CENTER_V2) {
            handleIframeClose();
            $window.location.href = '/v2/#/messages-ui/';
          } else if (messageType === CLOSE_DROPDOWN_PREVIEW) {
            handleIframeClose();
          }
        };

        const removeMessageListener = function () {
          $window.removeEventListener('message', handleMessage);
        };

        $window.addEventListener('message', handleMessage);

        IFrameModalService.open(url, true);
      };

      $scope.openMessageCenter = function () {
        const url = $scope.isMessageCenterV2Enabled ? '/v2/#/messages-ui/' : '/messages-ui/#';
        $window.location.href = url;
      };

      let clickTimer;
      $scope.handleClick = function () {
        if (!$scope.isFullWidthEnabled) {
          return $scope.openDropdown();
        }
        if (clickTimer) {
          $timeout.cancel(clickTimer);
          $scope.openMessageCenter();
        } else {
          clickTimer = $timeout(() => {
            clickTimer = null;
            $scope.openDropdown();
          }, 500);
        }
      }

      featureSet.load().then((features) => {
        $scope.realtimeRefresh = !!features['dark-feature.messaging-realtime-refresh'];
        $scope.isFullWidthEnabled = !!features['dark-feature.message-center-full-width'];
        $scope.isMessageCenterV2Enabled = !!features['dark-feature.message-center.v2'];
      });

      // ENGA-2500 update badge count from the broadcast
      const deRegister = $rootScope.$on('message-center-convo-full.new-message-count', (event, count) => {
        const badgeCount = $scope.notificationCount.newMessageCount + count;
        if ($scope.realtimeRefresh && badgeCount >= 0) {
          $scope.notificationCount.newMessageCount = badgeCount;
        }
      });

      $scope.$on('$destroy', deRegister);
    }])
  .directive('messagingDropdownMenu', [
    function () {
      return {
        restrict: 'EA',
        replace: true,
        controller: 'MessagingDropdownMenuCtrl',
        template: require('./dropdown-menu.pug')()
      };
    }])
  .factory('NotificationCountService', [
    'messagingDropdown', '$interval', '$timeout', '$rootScope', '$cookies', 'featureSet',
    function (messagingDropdown, $interval, $timeout, $rootScope, $cookies, featureSet) {
      var notificationCount = {
        newMessageCount: 0
      };

      const sid = $cookies.get(SESSION_ID_COOKIE_NAME);
      var disableMessagingNotifications = featureSet.features()['dark-feature.disable-messaging-notifications'];
      if (!disableMessagingNotifications) {
        if (WebSocket) {
          startWebsockets();
        } else {
          startLegacyPolling();
        }
      }

      return {
        notificationCount
      };

      function startLegacyPolling() {
        function getMessageCount() {
          messagingDropdown.getNotificationCount()
            .then((count) => {
              notificationCount.newMessageCount = count;
              $rootScope.$broadcast('notification-count-service.new-message-count', count);
            });
        }

        getMessageCount();
        $interval(getMessageCount, 30000);
      }

      // TODO: this needs to be moved into its own service for other people to use push notifications
      // Being left here while we test errors and reconnects with the fallback for legacy polling
      // When we move it to its own service we would either need to support generic polling (sockjs?) or not have a fallback
      function startWebsockets() {
        var websocketError = false;
        let useCaching = featureSet.features()['dark-feature.cache-messaging-notifications'];
        if (useCaching) {
          const count = getWithExpiry(SESSION_STORAGE_PREFIX, sid);
          if (count !== null) {
            $rootScope.$broadcast('notification-count-service.new-message-count', count);
            notificationCount.newMessageCount = count;
          } else {
            messagingDropdown.getNotificationCount()
              .then((count) => {
                notificationCount.newMessageCount = count;
                setWithExpiry(SESSION_STORAGE_PREFIX, sid, count, TTL_IN_SECONDS);
                $rootScope.$broadcast('notification-count-service.new-message-count', count);
              });
          }
        }
        openWebSocket();
        function openWebSocket() {
          var heartbeatInterval;
          var protocolPrefix = (window.location.protocol === 'https:') ? 'wss:' : 'ws:';
          var webSocket = new WebSocket(protocolPrefix + '//' + location.host + '/websockets-ui/ws/notifications');

          webSocket.onerror = function (event) {
            websocketError = true;
          };

          webSocket.onclose = function (event) {
            $interval.cancel(heartbeatInterval);
            // we may be deploying and migrating hosts
            if (!websocketError) {
              $timeout(openWebSocket, 5000);
            }
          };

          webSocket.onopen = function (event) {
            websocketError = false;
            heartbeatInterval = $interval(() => webSocket.send('heartbeat'), 25000);
          };

          webSocket.onmessage = function (event) {
            if (event && event.data) {
              $rootScope.$apply(() => {
                var message = JSON.parse(event.data);
                if (message.type == 'NewConversationCount') {
                  notificationCount.newMessageCount = message.value;
                  setWithExpiry(SESSION_STORAGE_PREFIX, sid, message.value, TTL_IN_SECONDS);
                  $rootScope.$broadcast('notification-count-service.new-message-count', message.value);
                }
              });
            }
          };
        }
      }
    }]);

